import React, { useState } from 'react';
import './Participants.css';

/* Who is taking part: photo (or initial) + name, and "Joined" or "Project sent ✓".
   Shown before and during a challenge, never with the project links. */
const Face = ({ p }) => {
  const [broken, setBroken] = useState(false);
  return (
    <span className="rmpt-face">
      {p.photo && !broken ? <img src={p.photo} alt="" loading="lazy" onError={() => setBroken(true)} /> : <span>{String(p.name || '?').charAt(0)}</span>}
    </span>
  );
};

const Participants = ({ list = [], max, compact = false }) => {
  if (!list.length) return null;
  const shown = max ? list.slice(0, max) : list;
  const more = list.length - shown.length;

  if (compact) {
    return (
      <div className="rmpt-stack" aria-label={`${list.length} students already joined`}>
        {shown.map((p) => (
          <Face key={p.id} p={p} />
        ))}
        {more > 0 && <span className="rmpt-face rmpt-more">+{more}</span>}
      </div>
    );
  }

  return (
    <ul className="rmpt-grid" aria-label="Students taking part">
      {shown.map((p) => (
        <li key={p.id} className={p.mine ? 'is-mine' : ''}>
          <Face p={p} />
          <b>{p.name}</b>
          <small className={p.sent ? 'is-sent' : 'is-joined'}>{p.mine ? (p.sent ? 'You · project sent ✓' : 'You · joined') : p.sent ? 'Project sent ✓' : 'Joined'}</small>
        </li>
      ))}
      {more > 0 && (
        <li className="rmpt-more-card">
          <b>+{more}</b>
          <small>more</small>
        </li>
      )}
    </ul>
  );
};

export default Participants;
